import React, {useState, useEffect} from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";

import NewReleasesIcon from "@mui/icons-material/NewReleases";

import apiDirectus from "../../service/api/ApiDirectus";
import {notifyError} from "../../service/AuthenticatedApi";

import {Release} from "../../interfaces/directus/Release";

import {formatDateShort} from "../../service/format/FormatDateTime";
import {useTranslation} from "react-i18next";

export default function ReleasesCard() {
  const {t} = useTranslation();
  const [releases, setReleases] = useState<Release[] | null>(null);

  useEffect(() => {
    apiDirectus
      .getFeatures()
      .then((data) => setReleases(data))
      .catch((error: unknown) => {
        // Liste vide plutôt qu'un chargement sans fin
        setReleases([]);
        notifyError(t("error.loadReleases"))(error);
      });
  }, []);

  return (
    <Card className="custom-card" style={{height: "550px"}} data-testid="releasesCard">
      <CardContent>
        <Toolbar style={{marginLeft: "5px", marginTop: "-10px", padding: 0}}>
          <NewReleasesIcon fontSize="large" style={{marginRight: "10px"}}></NewReleasesIcon>
          <Typography variant="h5">{t("home.releases")}</Typography>
        </Toolbar>
        <List style={{marginTop: "-5px", height: "460px", overflow: "overlay"}}>
          {releases === null ? (
            <CircularProgress size={20} />
          ) : (
            releases.map(({published, features}, i) => (
              <ListItem style={{marginBottom: "-15px"}} key={i}>
                <ListItemText
                  style={{marginTop: "-5px"}}
                  disableTypography
                  primary={
                    <Typography style={{fontWeight: "bold", marginBottom: "5px"}} variant="subtitle1">
                      {formatDateShort(published)}
                    </Typography>
                  }
                  secondary={
                    <>
                      {features.map(({id, title, description, url}) => (
                        <div style={{marginLeft: "15px", marginBottom: "10px"}} key={id}>
                          <Typography
                            style={{
                              fontWeight: "bold",
                              marginBottom: "-10px",
                            }}
                            variant="subtitle1"
                            color="primary">
                            • {title}
                          </Typography>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: description,
                            }}></div>
                          {url && <a href={url}>{t("home.learnMore")}</a>}
                        </div>
                      ))}
                    </>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
      </CardContent>
    </Card>
  );
}
